import { BigNumber } from '@xylabs/sdk-js'

export const shiftBase10 = (bn: BigNumber | undefined | null, positions: number) => {
  if (bn === undefined) {
    return undefined
  }
  if (bn === null) {
    return null
  }
  const factor = new BigNumber(10).pow(new BigNumber(Math.abs(positions)))
  if (positions > 0) {
    return bn.mul(factor)
  } else {
    return bn.div(factor)
  }
}
